import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import MainLayout from '../../components/MainLayout';
import { Button } from '../../components/ui/button';

export default function CreditsCancel() {
  const navigate = useNavigate();
  return (
    <MainLayout>
      <div className="max-w-lg mx-auto text-center py-20 px-4" data-testid="credits-cancel-page">
        <XCircle className="h-10 w-10 mx-auto text-slate-400" />
        <h1 className="text-xl font-bold mt-3">Payment cancelled</h1>
        <p className="text-sm text-slate-500 mt-1">
          No charge was made. Your wallet balance is unchanged.
        </p>
        <div className="mt-6 flex justify-center gap-2">
          <Button variant="outline" className="rounded-none" onClick={() => navigate(-1)} data-testid="credits-cancel-back">
            <ArrowLeft className="h-4 w-4 mr-1" /> Go back
          </Button>
          <Button className="rounded-none" onClick={() => navigate('/dashboard')} data-testid="credits-cancel-home">
            Home
          </Button>
        </div>
      </div>
    </MainLayout>
  );
}
